import { consults_for_followup, consults_for_weight_loss_followup } from "@iscr/views/med/utils";
/**
 * Returns true if the patient is eligible for a free weight management program follow-up consultation.
 *
 * The patient gets "one free follow-up per [four week subscription cycle]". Base this on the last medsubwl prescription
 * in their history.
 */
export function free_weight_loss_program_followup_available() {
    var _a;
    const history = (_a = app.user.prof) === null || _a === void 0 ? void 0 : _a.hist;
    // Find the most recent medication prescription issued for a weight management program.
    const anchorIndex = history === null || history === void 0 ? void 0 : history.findIndex(item => item.script_type === "medsub" && item.req_type === "medsubwl");
    // Test whether any patient-initiated follow-ups have occurred more recently than the anchor.
    return !history || anchorIndex === -1
        ? false
        : !history.slice(0, anchorIndex).some(item => 
        // follow-ups scheduled by the backend don't have a defined meta_ref_sid, but ones created by patients do.
        item.req_type === "subconswlfu" && item.meta_ref_sid);
}
const has_weight_loss_program_presc = (uid) => { var _a; return ((_a = app.user.prof.pts_prescs) !== null && _a !== void 0 ? _a : []).some((presc) => { var _a; return presc.uid === uid && ((_a = presc.med) === null || _a === void 0 ? void 0 : _a.mid) === "SubConsWLFU"; }); };
// Test if a patient's most recent SubConsWL-family consult resulted in a Weight Management Program.
export const is_weight_loss_program_patient = (uid) => consults_for_followup("SubConsWLFU", uid)
    .slice(0, 1)
    .some((consult) => { var _a; 
// If a SubConsWL-style consult doesn't have a program option, it predates the ability to opt out, so
// default it to "program".
return ((_a = consult.meta__weight_management_program_option) !== null && _a !== void 0 ? _a : "program") === "program"; });
const weightLossCategoryToLinks = {
    "wl-new-patient": "/treatment/weight-loss",
    "wl-consult-patient": "/m/pharm/DocCons/DocConsWLFU",
    "wl-program-patient": "/m/pharm/subscr/SubConsWLFU",
};
export const get_wl_link_for_patient_category = (category) => weightLossCategoryToLinks[category];
export const get_wl_patient_category_for_uid = (uid) => is_weight_loss_program_patient(uid) || has_weight_loss_program_presc(uid)
    ? "wl-program-patient"
    : consults_for_weight_loss_followup("DocConsWLFU", uid).length ||
        consults_for_followup("DocConsWLFU", uid).length
        ? "wl-consult-patient"
        : "wl-new-patient";
// Return a map of WL patient categories to the profiles which fall into that category.
export const get_wl_category_for_all_profiles = () => {
    var _a, _b;
    return ((_b = (_a = app.user) === null || _a === void 0 ? void 0 : _a.profs) !== null && _b !== void 0 ? _b : []).reduce((all, profile) => {
        const category = get_wl_patient_category_for_uid(profile.uid);
        if (!all[category]) {
            all[category] = [];
        }
        all[category].push(profile);
        return all;
    }, {});
};
